import { CommonAjaxPostLoginRequest, CommonAxiosPost, CommonAxiosPostLogin } from "../CommonUtils/CommonAxios";
import { config } from "../CommonUtils/CommonURLS";

class AuthenticationApiServices {
    LoginPost(req) {
        return CommonAjaxPostLoginRequest(config.url.AUTHENTICATION_URL, req);
    }
    ChangePasswordPost(req) {
        return CommonAxiosPost("changepasword", req);
    }
    RefreshTokenPost(req) {
        return CommonAxiosPostLogin("api/auth/refresh-token", req);
    }
    

    
}
export default new AuthenticationApiServices();